import { useQuery } from '@tanstack/react-query'
import type { User } from 'firebase/auth'
import { getAuth } from 'firebase/auth'
import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { QueryHook } from '@/lib/react-query'

export const userQueryKeys = createQueryKeys('USER', {
  authData: null,
})

export const useUser = ({ options }: QueryHook<User | null> = {}) => {
  return useQuery({
    queryKey: userQueryKeys.authData.queryKey,
    queryFn: () => {
      const auth = getAuth()

      return auth.currentUser
    },
    staleTime: Number.POSITIVE_INFINITY,
    ...options,
  })
}
